import React from 'react';

/**
 * Componente Card reutilizável para exibição de informações
 * @param {object} props - Propriedades do componente
 * @param {React.ReactNode} props.children - Conteúdo do card
 * @param {string} [props.title] - Título opcional do card
 * @param {string} [props.variant='default'] - Variante do card (default, outline, flat)
 * @param {string} [props.className] - Classes adicionais
 * @param {boolean} [props.hoverable=false] - Se o card deve ter efeito hover
 * @param {function} [props.onClick] - Função de clique (transforma o card em clicável)
 */
const Card = ({
  children,
  title,
  variant = 'default',
  className = '',
  hoverable = false,
  onClick,
  ...props
}) => {
  // Variantes de estilo
  const variantStyles = {
    default: 'bg-white shadow-sm',
    outline: 'bg-white border border-gray-200',
    flat: 'bg-gray-50'
  };

  // Classes base
  const baseClasses = 'rounded-xl overflow-hidden';
  
  // Classes para título
  const titleClasses = 'text-sm font-medium text-gray-800 px-3 py-2 border-b border-gray-100';
  
  // Classes combinadas
  const combinedClasses = `
    ${baseClasses}
    ${variantStyles[variant]}
    ${hoverable ? 'transition-all duration-200 hover:shadow-md hover:translate-y-[-1px]' : ''}
    ${onClick ? 'cursor-pointer' : ''}
    ${className}
  `;

  return (
    <div 
      className={combinedClasses}
      onClick={onClick}
      {...props}
    >
      {title && (
        <div className={titleClasses}>
          {title}
        </div>
      )}
      <div>
        {children}
      </div>
    </div>
  );
};

export default Card; 